import {
    faCalendarAlt,
    faCheckCircle,
    faChevronCircleRight,
    faClock,
    faInfoCircle,
    faPencilAlt,
    faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MyLocation } from "@material-ui/icons";
import React from "react";

const GenericIcon = ({ className, icon }: any) => <FontAwesomeIcon className={className} icon={icon} />;

const InfoIcon = ({ className }: any) => <GenericIcon className={className} icon={faInfoCircle} />;

const QuestionIcon = ({ className }: any) => <GenericIcon className={className} icon={faQuestionCircle} />;

const PencilIcon = ({ className }: any) => <GenericIcon className={className} icon={faPencilAlt} />;

const CalendarIcon = ({ className }: any) => <GenericIcon className={className} icon={faCalendarAlt} />;

const ClockIcon = ({ className }: any) => <GenericIcon className={className} icon={faClock} />;

const CircleCheck = ({ className }: any) => <GenericIcon className={className} icon={faCheckCircle} />;

const CircleRight = ({ className }: any) => <GenericIcon className={className} icon={faChevronCircleRight} />;

export { CalendarIcon, CircleCheck, CircleRight, ClockIcon, InfoIcon, MyLocation, PencilIcon, QuestionIcon };
